import { makeAutoObservable } from 'mobx';
import User, { UserDto } from './User';

export default class Users {
  items: User[] = [];

  constructor(
    usersDto: UserDto[],
    private readonly onSave?: (user: User) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
    this.items = usersDto.map((dto) => this.unSerialize(dto));
  }

  get isEmpty(): boolean {
    return this.items.length === 0;
  }

  getById(userId: string): undefined | User {
    return this.items.find((user) => user.id === userId);
  }

  private async saveUser(user: User) {
    return this.onSave?.(user);
  }

  private unSerialize(dto: UserDto): User {
    return new User(dto, this.saveUser);
  }
}
